import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { useCompanyCurrency } from '~hooks/useCompanyCurrency/useCompanyCurrency';
import { Settlement } from '~hooks/useSettlements/models';

export const SettlementPricing = ({ settlement }: { settlement: Settlement }) => {
  const { currencyFormatter } = useCompanyCurrency();

  const total = settlement.rebillTotalAmount ?? settlement.totalAmount;

  const invoicesTotal =
    settlement.rebillInvoicesTotalAmount ?? settlement.invoicesTotalAmount;

  const addOnsTotal =
    settlement.rebillAddOnChargesTotalAmount ?? settlement.addOnChargesTotalAmount;

  const taxTotal =
    settlement.rebillInvoicesTaxTotalAmount ?? settlement.invoicesTaxTotalAmount;

  return (
    <Box
      sx={{
        gap: 1,
        border: (theme) => `1px solid ${theme.semantic.border}`,
        borderRadius: '6px',
        width: '200px',
        height: 'fit-content',
        backgroundColor: (theme) => theme.semantic.surfaceRaised,
        p: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Typography variant="body2">
          {t('approvals.driver_pay.settlements.subtotal')}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: '600',
          }}
        >
          {' '}
          {currencyFormatter(invoicesTotal.toFixed(2))}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Typography variant="body2">
          {t('approvals.driver_pay.settlements.add_ons')}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: '600',
          }}
        >
          {addOnsTotal
            ? addOnsTotal > 0
              ? currencyFormatter(addOnsTotal.toFixed(2))
              : `(${currencyFormatter(-addOnsTotal.toFixed(2))})`
            : currencyFormatter('0.00')}
        </Typography>
      </Box>
      {taxTotal ? (
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Typography variant="body2">
            {t('approvals.driver_pay.settlements.tax')}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: '600',
            }}
          >
            {currencyFormatter(taxTotal.toFixed(2))}
          </Typography>
        </Box>
      ) : null}
      <Box
        sx={{
          width: '100%',
          height: '1px',
          backgroundColor: (theme) => theme.brandV2.colors.treadGray7,
        }}
      />
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Typography variant="body2">
          {t('approvals.driver_pay.tabs.driver_pay.total')}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: '600',
          }}
        >
          {total
            ? total > 0
              ? currencyFormatter(total.toFixed(2))
              : `(${currencyFormatter(-total.toFixed(2))})`
            : currencyFormatter('0.00')}
        </Typography>
      </Box>
    </Box>
  );
};
